// extracted by mini-css-extract-plugin
export default {"modalHeader":"modal_modalHeader__RGTbx","closeButton":"modal_closeButton__hYa4+","modalLineHeader":"modal_modalLineHeader__4Xemi","secondaryTitle":"modal_secondaryTitle__L6Pyq"};